import { Flex, Tag, theme } from 'antd';
import { FC, memo } from 'react';
import { PatchExclamationFill } from 'react-bootstrap-icons';

import { AppAutocomplete, DomainPunycode } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteAllGoogleVerificatedDomainsBySiteIdQuery } from '@/modules/Domains/queries';

interface Props extends AppAutocompleteComponentProps {
  siteId: string;
}

export const DomainsGoogleVerificatedAutocomplete: FC<Props> = memo(({ siteId, ...props }) => {
  const { token: { colorError } } = theme.useToken();
  return (
    <AppAutocomplete<typeof useAutocompleteAllGoogleVerificatedDomainsBySiteIdQuery>
      { ...props }
      notFoundDescription="Немає доменів"
      placeholder="Знайдіть домени"
      queryArgs={ [siteId] }
      mode="multiple"
      searchWithoutQuery
      optionItemRender={
        ({ name, isGoogleVerificated }) =>
          <Flex justify="flex-start" align="center" gap={ 4 }>
            <span>{ DomainPunycode.stringFormat(name) }</span>
            { !isGoogleVerificated && <Tag color="geekblue" icon={ <PatchExclamationFill color={ colorError }/> }>Google</Tag> }
          </Flex>
      }
      options={ (data) =>
        // TODO:
        parseSelectData(
          data,
          {
            value: 'id',
            label: 'name',
            disabled: ({ isGoogleVerificated }) => !isGoogleVerificated,
          }
        )
      }
      query={ useAutocompleteAllGoogleVerificatedDomainsBySiteIdQuery }
    />
  );
});
